/* global gtag */
import React, { useState, useEffect } from 'react';
import { Container, BackChoice, ButtonGroup, InputAuth,  ButtonNext, ButtonSend, ModalWrapper, InputWrapper, Label, StyledH3, StyledH2, StyledInfo } from './styles';
import api from '../../services/client/api'; 
import {Alert, FormGroup, Input} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope,  faPaperPlane, faPhone, faArrowAltCircleLeft, faCheck, faInfoCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const RecoveryAcess = ({ onClose, tel, mail, username }) => {
  const [preferredContact, setPreferredContact] = useState(null);
  const [emailChoosed, setEmailChoosed] = useState(false);  // Estado para controlar se o e-mail foi escolhido
  const [phoneChoosed, setPhoneChoosed] = useState(false); 
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [errorReturn, setError] = useState('');
  const [showBackChoice, setShowBackChoice] = useState(true); 
  const [showInput, setShowInput] = useState(false);
  const [, setSendingCode] = useState(false);
  const [messageSended, setMessageSended] = useState(false);

  const sendMailCode = async () => {
    setSendingCode(true);

    try {
      // Enviar código de recuperação por e-mail

      const response = await api().user().sendMailRecovery(mail.String, username);
  
      if (response.status === 200) {
           // ✅ GA4: Mail sended
          gtag('event', 'mail_sended', {
            event_category: 'send_mail_recovery',
            value: 200
          });
        setMessageSended(true);
        setShowInput(true);
 

      }
      
  
    } catch (error) {
      window.alert(`Erro ao enviar código de recuperação via E-mail. Atualize a página e tente novamente.`);
    }finally {
      setSendingCode(false); // Marca como não enviando o código
    }
  };
  const sendSmsCode = async () => {
    setSendingCode(true);
  

 
    try {
      // Verificar e adicionar o código do Brasil (55) se não estiver presente
    
   
      // Enviar código de recuperação por telefone
      const response = await api().user().sendPhoneRecovery(tel.String, username);

      if (response.status === 200) {
          // ✅ GA4: SMS sended
          gtag('event', 'sms_sended', {
            event_category: 'send_sms_recovery',
            value: 200
          });
        setMessageSended(true);
        setShowInput(true);
      
        setTimeout(() => {
          setMessageSended(false); // Altera o estado para false após 60 segundos
        }, 300000); // 60000 milissegundos = 60 segundos
      }
       else{
        alert("Falha no envio do SMS, tente novamente mais tarde.");
      }
      
  
    } catch (error) {
     
      window.alert(`Erro ao enviar código de recuperação via SMS. Atualize a página e tente novamente.`);
    } finally {
      setSendingCode(false); // Marca como não enviando o código
    }
  };
  
  



useEffect(() => {
      if (mail.String !== "none" && tel.String !== "none") {
        setPreferredContact('email'); // Definir o e-mail como padrão (pode ser alterado pelo usuário)
      } else {
        // Verificar se o email é nulo
        if (mail.String === "none") {
          setPhoneChoosed(true); // Se o email for nulo, define que o telefone foi escolhido
          setShowBackChoice(false); // Se for nulo, desativa a escolha
        }
        // Verificar se o telefone é nulo
        if (tel.String === "none") {
          setEmailChoosed(true); // Se o telefone for nulo, define que o email foi escolhido
          setShowBackChoice(false); // Se for nulo, desativa a escolha
        }
      }
    }, [mail, tel]);
  
  const handleChange = (event) => {
    setPreferredContact(event.target.value);
  };

   const maskEmail = (email) => {
  // Se for objeto com a propriedade .String, usa ela
  if (typeof email === 'object' && email !== null && email.String) {
    email = email.String;
  }

  // Agora segue o fluxo normal
  if (typeof email !== 'string' || !email || email === "none" || !email.includes('@')) {
    return email;
  }

  const [localPart, domain] = email.split('@');
  if (!domain || !localPart) return email;

  const maskedLocalPart = localPart.slice(0, 2) + '*'.repeat(Math.max(0, localPart.length - 3)) + localPart.slice(-1);
  const [domainName, domainExt] = domain.split('.');
  if (!domainName || !domainExt) return email;

  const maskedDomain = domainName[0] + '*'.repeat(Math.max(0, domainName.length - 1)) + '.' + domainExt;
  return `${maskedLocalPart}@${maskedDomain}`;
};

const maskPhone = (phone) => {
  // Se for objeto com propriedade .String, usa ela
  if (typeof phone === 'object' && phone !== null && phone.String) {
    phone = phone.String;
  }

  if (typeof phone !== 'string' || !phone || phone === "none" || phone.length < 3) {
    return phone; // retorna como está se for "none", null, undefined ou muito curto
  }

  // Remove os dois primeiros dígitos (código do país)
  const cleanPhone = phone.replace(/^\d{2}/, '');

  return `(**) *****-*${cleanPhone.slice(-3)}`;
};


  
  // Função para controlar a escolha do e-mail
  const handleContinue = () => {
    if (preferredContact === 'email') {
      setEmailChoosed(true); // Marca o e-mail como escolhido
    } else if (preferredContact === 'phone') {
      setPhoneChoosed(true); // Marca o e-mail como escolhido
    }
  };


// Função que lida com a mudança do código
const handleCodeChange = async (e, index) => {
   const value = e.target.value; 
    // Permite apenas números de 0 a 9
  if (!/^\d?$/.test(value)) return;
  const newCode = [...code]; // Fazemos uma cópia do estado atual
  newCode[index] = value; // Atualiza o valor no índice específico do campo

  setCode(newCode); // Atualiza o estado com o novo código

  const concatenatedCode = newCode.join(''); // Junta todos os valores dos campos

  // Se o código for completo (6 dígitos)
  if (/^[A-Za-z0-9]{6}$/.test(concatenatedCode)) {
   
    try {
      const response = await api().user().checkCode(concatenatedCode, username);
    
      if (response.status === 200) {
        onClose();
      }
    } catch (error) {
      const status = error.response?.status;

      if (status === 400) {
        setError('Código inválido.');
      } else {
        setError('Ocorreu um erro ao verificar o código.');
      }
    }
    
  } 

  // Navega automaticamente para o próximo campo, se possível
  if (value && index < 5) {
    setTimeout(() => {
      document.getElementById(`input-${index + 1}`).focus();
    }, 100); // Pequeno delay para garantir que a renderização aconteça
  }
};

// Função que lida com o evento de Backspace
const handleBackspace = (e, index) => {
  // Se a tecla pressionada for o Backspace
  if (e.key === 'Backspace') {
    const newCode = [...code];

    if (code[index] === '') {
      // Se o campo atual estiver vazio, move o foco para o campo anterior
      if (index > 0) {
        // Apaga o valor do campo anterior
        newCode[index - 1] = '';
        setCode(newCode); // Atualiza o código
        setTimeout(() => {
          document.getElementById(`input-${index - 1}`).focus(); // Mover o foco para o campo anterior
        }, 100); // Delay para garantir que o foco seja movido após a atualização do estado
      }
    }
  }
};

// Função que move o foco para o próximo campo
const handleFocus = (e, index) => {
  if (e.target.value.length === 1 && index < 5) {
    // Mover o foco para o próximo campo (caso não seja o último)
    document.getElementById(`input-${index + 1}`).focus();
  }
};


const resetReturnError = () => {
  setError('');
};
  return (
    /* outras parte do codigo */
    <Container>
  <ModalWrapper>
      {!emailChoosed && !phoneChoosed && (
        <>
                    <StyledH3>
                      Você prefere receber&nbsp;a&nbsp;confirmação por&nbsp;E-mail ou&nbsp;SMS?
                    </StyledH3>
  
          {mail && tel && (
          <FormGroup tag="fieldset" style={{ textAlign: 'center' }}>
          {mail !== 'none' && (
          <FormGroup check style={{ marginBottom: '15px' }}>
            <Label check style={{ fontSize: '18px' }}>
              <Input
                type="radio"
                name="preferredContact"
                value="email"
                checked={preferredContact === 'email'}
                onChange={handleChange}
                disabled={phoneChoosed}
              />
              <FontAwesomeIcon icon={faEnvelope} style={{ margin: '0 8px' }} />
              E-mail: <b>{maskEmail(mail)}</b>
            </Label>
          </FormGroup>
          )}
          {tel !== 'none' && (
          <FormGroup check style={{ marginBottom: '15px' }}>
            <Label check style={{ fontSize: '18px' }}>
              <Input
                type="radio"
                name="preferredContact"
                value="phone"
                checked={preferredContact === 'phone'}
                onChange={handleChange}
                disabled={emailChoosed}
              />
              <FontAwesomeIcon icon={faPhone} style={{ margin: '0 8px' }} />
              Telefone: <b>{maskPhone(tel)}</b>
            </Label>
          </FormGroup>
         )}
          <ButtonGroup>
            <ButtonNext color="primary" onClick={handleContinue}>
              Continuar
            </ButtonNext>
          </ButtonGroup>
        </FormGroup>
          )}
        </>
      )}
  
      {phoneChoosed && (
        <>
{messageSended ? (
  <>
    <StyledH2>
      Código enviado
      <FontAwesomeIcon icon={faCheck} style={{ color: "#4FC3F7", marginLeft: "6px" }} />
    </StyledH2>

    <StyledH3>
      Verifique seu SMS e digite o código no campo abaixo.
    </StyledH3>

    <StyledInfo>
      <FontAwesomeIcon icon={faInfoCircle} style={{ marginRight: "6px", color: "#4FC3F7" }} />
      Lembre-se de verificar também sua <b>caixa de spam.</b>
    </StyledInfo>
  </>
) : (
  <>
    <StyledH3>
      Clique no botão para enviar o código ao seu SMS.
    </StyledH3>
   <Label><FontAwesomeIcon icon={faPhone} style={{marginRight:'5px' }}/>Telefone: <b>{maskPhone(tel)}</b></Label>
 

          <ButtonGroup>
          <ButtonSend
            color="primary"
            onClick={() => {
              resetReturnError();
              sendSmsCode();
            }}
          
          >
            <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: '5px' }} /> Enviar Código
          </ButtonSend>
            
          </ButtonGroup>
        </>
)} 
          {showInput &&(
         
                    <InputWrapper>
            {code.map((digit, index) => (
              <InputAuth
                key={index}
                id={`input-${index}`}
                maxLength="1"
                type="text"
                inputMode="numeric"          // Garante que apareça o teclado numérico
                pattern="[0-9]*"             // Ajuda com dispositivos Android
                placeholder="-"
                value={digit}
                onChange={(e) => handleCodeChange(e, index)} // Altera o valor
                onKeyUp={(e) => handleBackspace(e, index)}   // Aciona o backspace
                onFocus={(e) => handleFocus(e, index)}       // Move o foco para o próximo campo
                                      // Verifica se o campo está desabilitado
              />
            ))}
          </InputWrapper>
                 
             
  )}
   
{showBackChoice &&(
      <ButtonGroup>
       <BackChoice color="secondary" onClick={() => { setPhoneChoosed(false); setEmailChoosed(false);  setMessageSended(false); setShowInput(false);}}>
        <FontAwesomeIcon icon={faArrowAltCircleLeft}  />
          Alterar Escolha
        </BackChoice>
      </ButtonGroup>
)}
        </>
      )}
      {/* outras parte do codigo */}
      {emailChoosed && (
        <>
        
      {messageSended ? (
  <>
    <StyledH2>
      Código enviado
      <FontAwesomeIcon icon={faCheck} style={{ color: "#4FC3F7", marginLeft: "6px" }} />
    </StyledH2>

    <StyledH3>
      Verifique seu e-mail e digite o código no campo abaixo.
    </StyledH3>

    <StyledInfo>
      <FontAwesomeIcon icon={faInfoCircle} style={{ marginRight: "6px", color: "#4FC3F7" }} />
      Lembre-se de verificar também sua <b>caixa de spam.</b>
    </StyledInfo>
  </>
) : (
  <>
    <StyledH3>
      Clique no botão para enviar o código ao seu e-mail.
    </StyledH3>

    <Label>
      <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: "5px" }} />
      E-mail: <b>{maskEmail(mail)}</b>
    </Label>

    <ButtonGroup>
      <ButtonSend
        color="primary"
        onClick={() => {
          resetReturnError();
          sendMailCode();
        }}
      >
        <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: "5px" }} />
        Enviar Código
      </ButtonSend>
    </ButtonGroup>
  </>
)}

    {showInput &&(
      <>
      
              <InputWrapper>
      {code.map((digit, index) => (
        <InputAuth
          key={index}
          id={`input-${index}`}
          maxLength="1"
          type="text"
          placeholder="-"
          value={digit}
          onChange={(e) => handleCodeChange(e, index)} // Altera o valor
          onKeyUp={(e) => handleBackspace(e, index)}   // Aciona o backspace
          onFocus={(e) => handleFocus(e, index)}       // Move o foco para o próximo campo
                                    // Verifica se o campo está desabilitado
        />
      ))}
        
    </InputWrapper>
                </> )}      


    {errorReturn &&  (
                    <Alert color='danger' style={{margin: '10px 0px 0px 0px'}}>Código incorreto</Alert>
                  )}
                         {showBackChoice &&(
      <ButtonGroup>
 
        <BackChoice color="secondary" onClick={() => { setPhoneChoosed(false); setEmailChoosed(false);  setMessageSended(false); setShowInput(false);}}>
        <FontAwesomeIcon icon={faQuestionCircle}  />
          Tentar de outra forma
        </BackChoice>
      </ButtonGroup>
    )}
        </>
      )}
      </ModalWrapper>
    </Container>
  );
  
  
};

export default RecoveryAcess;
